import { schema } from 'normalizr';

export const draftLabelSchema = new schema.Entity(
  'draftLabels',
  {},
  { idAttribute: 'DraftLabelId' },
);

export const draftLabelListSchema = [draftLabelSchema];
